export default __webpack_public_path__ + "static/zipolite-mexico-6486685e9783798c82d3cb6a613ca9f7.jpg";